import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radio, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export function LiveNowCard() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/challonge/active").then((r) => setItems((r.data.active || []).filter((x) => x.live || x.state !== "complete"))).catch(() => {});
  }, []);
  if (items.length === 0) return null;
  return (
    <div className="space-y-3" data-testid="live-now-cards">
      {items.map((t) => (
        <Link key={t.local_tournament_id} to={`/tournaments/${t.local_tournament_id}/live`} data-testid={`live-now-${t.local_tournament_id}`}
          className="group block rounded-xl border-2 border-[#E11D2A] bg-[#0B0B0C] text-white p-5 hover:shadow-lg transition-all">
          <div className="flex items-center justify-between gap-3">
            <div>
              <span className="inline-flex items-center gap-2 text-[#E11D2A] text-xs font-bold uppercase tracking-wide">
                <span className="relative flex h-2.5 w-2.5"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#E11D2A] opacity-75" /><span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#E11D2A]" /></span>
                {t.live ? "Live Now" : "Tournament"}
              </span>
              <h3 className="font-heading font-extrabold text-xl mt-1">{t.name}</h3>
              <p className="text-sm text-gray-300 mt-1">{t.remaining} players remaining{t.latest?.winner ? ` · Latest: ${t.latest.winner} def. ${t.latest.winner === t.latest.player1 ? t.latest.player2 : t.latest.player1} ${t.latest.scores || ""}` : ""}</p>
            </div>
            <span className="inline-flex items-center gap-1 bg-[#E11D2A] rounded-md px-4 py-2 text-sm font-bold group-hover:gap-2 transition-all shrink-0">Follow Live <ArrowRight className="h-4 w-4" /></span>
          </div>
        </Link>
      ))}
    </div>
  );
}
